import PropTypes from 'prop-types';
import _startCase from 'lodash/startCase';
import * as analytics from 'Utils/analytics';
import MediaRail from 'Components/profile/MediaRail';
const { EVENTS } = analytics;

const LibraryList = (props) => {
  const { onDeleteListItem, ...rest } = props;
  const handleItemClick = (id) => {
    analytics.event({ action: EVENTS.selectLibraryItem, label: id });
  };

  return (
    <div className="library-list">
      <div className="row__label">{`Saved ${_startCase(
        props.type.toLowerCase()
      )}`}</div>
      <MediaRail
        {...rest}
        onItemActionClick={onDeleteListItem}
        onItemClick={handleItemClick}
      />
    </div>
  );
};

LibraryList.propTypes = {
  country: PropTypes.string.isRequired,
  hasError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  itemList: PropTypes.array.isRequired,
  itemMap: PropTypes.object.isRequired,
  onDeleteListItem: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  shouldLoadMore: PropTypes.bool.isRequired,
  strings: PropTypes.object.isRequired,
  totalCount: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
};

LibraryList.defaultProps = {};

export default LibraryList;
